import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';


import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { Rol } from './roles.model';

export const entityRolAdapter: EntityAdapter<Rol> = createEntityAdapter<Rol>({
  selectId: (model) => model.id,
  sortComparer: (a: Rol, b: Rol): number =>
    b.id.toString().localeCompare(a.id.toString())
});

export interface EntityRolState extends EntityState<Rol> {
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityRolState = entityRolAdapter.getInitialState({
  isLoading: false,
  error: null
});
